import React from 'react';
import PropTypes from 'prop-types';
import './Badge.scss';

export const Badge = ({ count, className = '' }) => {
  if (!count) return null;

  const displayCount = count > 99 ? '99+' : count;

  return (
    <span className={`notification-badge ${className}`}>{displayCount}</span>
  );
};

Badge.propTypes = {
  count: PropTypes.number,
  className: PropTypes.string,
};
